import { ensureCustomFilterStyle } from './filterStyles';

/**
 * 구분 필터 (복수 선택)
 * 사용 예: { filter: GubunFilter }
 */
class GubunFilter {
  init(params) {
    ensureCustomFilterStyle();
    this.params = params;
    this.model = null; // { selected: ["LEGEND", "REBUILD"] }
    this.onClose = params.onClose || null;
    this.gui = document.createElement('div');
    this.gui.className = 'aptrank-custom-filter';
    this.render();
  }

  isSelected(gubun) {
    return Array.isArray(this.model?.selected) && this.model.selected.includes(gubun);
  }

  toggleGubun(gubun) {
    const selected = new Set(Array.isArray(this.model?.selected) ? this.model.selected : []);
    if (selected.has(gubun)) {
      selected.delete(gubun);
    } else {
      selected.add(gubun);
    }
    const next = Array.from(selected);
    this.model = next.length > 0 ? { selected: next } : null;
  }

  render() {
    const gubuns = [
      { code: 'LEGEND', label: '레전드' },
      { code: 'REBUILD', label: '재건축' },
      { code: 'CAPTAIN', label: '대장' },
      { code: 'PRESALE_RIGHT', label: '분양권' },
      { code: 'HIGH_RANKER', label: '하이랭커' },
      { code: 'RENTAL', label: '임대' },
      { code: 'LANDMARK', label: '랜드마크' },
      { code: 'RANKER', label: '랭커' },
      { code: 'SELECTED', label: '선별' },
    ];

    this.gui.innerHTML = `
      <button type="button" class="complex-top-filter-panel-close" style="position: absolute; top: 8px; right: 8px; border: none; background: transparent; color: #64748b; width: 28px; height: 28px; border-radius: 8px; font-size: 24px; line-height: 1; cursor: pointer; z-index: 10;">×</button>
      <div class="aptrank-custom-filter-head">
        <div class="aptrank-custom-filter-heading">구분 선택 (복수 선택 가능)</div>
      </div>
      <div class="aptrank-custom-filter-grid" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; padding: 12px;">
        ${gubuns.map((gubun) => {
          const active = this.isSelected(gubun.code);
          return `<button
            class="aptrank-custom-filter-chip"
            data-gubun="${gubun.code}"
            style="
              height: 36px;
              padding: 0 12px;
              border: 1px solid ${active ? '#3b82f6' : '#cbd5e1'};
              border-radius: 6px;
              background: ${active ? '#eff6ff' : '#fff'};
              color: ${active ? '#1e40af' : '#475569'};
              font-size: 13px;
              font-weight: ${active ? '700' : '500'};
              cursor: pointer;
              transition: all 0.15s ease;
            "
          >${gubun.label}</button>`;
        }).join('')}
      </div>
      <div class="aptrank-custom-filter-actions">
        <button class="aptrank-custom-filter-reset" type="button">초기화</button>
        <button class="aptrank-custom-filter-apply" type="button">적용</button>
      </div>
    `;

    // 구분 버튼 클릭 시 토글
    this.gui.querySelectorAll('[data-gubun]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const gubun = btn.getAttribute('data-gubun');
        this.toggleGubun(gubun);
        this.render(); // 상태 업데이트를 위해 다시 렌더링
      });
    });

    // 초기화 버튼
    this.gui.querySelector('.aptrank-custom-filter-reset').addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      this.model = null;
      this.render();
    });

    // 적용 버튼
    this.gui.querySelector('.aptrank-custom-filter-apply').addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      this.params.filterChangedCallback();
    });

    // 닫기 버튼
    const closeBtn = this.gui.querySelector('.complex-top-filter-panel-close');
    if (closeBtn && this.onClose) {
      closeBtn.addEventListener('click', this.onClose);
    }
  }

  getGui() {
    return this.gui;
  }

  isFilterActive() {
    return Array.isArray(this.model?.selected) && this.model.selected.length > 0;
  }

  doesFilterPass(p) {
    if (!this.isFilterActive()) return true;
    const raw = this.params.valueGetter ? this.params.valueGetter(p.node) : p?.data?.[this.params.colDef?.field];
    const value = String(raw || '');
    // gubun 값에 선택된 값 중 하나라도 포함되어 있으면 true
    return this.model.selected.some((selected) => value.includes(selected));
  }

  getModel() {
    return this.model;
  }

  setModel(model) {
    this.model = model || null;
    if (this.gui) this.render();
  }
}

export default GubunFilter;
